export default __webpack_public_path__ + "static/media/tv.31493b1f.jpg";